import axios from "axios";
import { getStoredLang } from "./i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });
const L = () => ({ params: { lang: getStoredLang() } });

export const getCommunities = () => client.get("/communities", L()).then((r) => r.data);
export const recordVisit = () => client.post("/visit").then((r) => r.data).catch(() => {});
export const startSession = (community_id, mode = "deep", from_quick = false) =>
  client.post("/sessions", { community_id, mode, from_quick }, L()).then((r) => r.data);
export const submitChoice = (sessionId, choice_id, reflection) =>
  client.post(`/sessions/${sessionId}/choice`, { choice_id, reflection }, L()).then((r) => r.data);
export const undoChoice = (sessionId) =>
  client.post(`/sessions/${sessionId}/undo`, {}, L()).then((r) => r.data);
export const getSummary = (sessionId) =>
  client.get(`/sessions/${sessionId}/summary`, L()).then((r) => r.data);
export const resumeSession = (sessionId) =>
  client.get(`/sessions/${sessionId}/resume`, L()).then((r) => r.data);
export const addComment = (sessionId, text) =>
  client.post(`/sessions/${sessionId}/comment`, { text }).then((r) => r.data);
export const submitContribution = (payload) =>
  client.post("/contributions", payload).then((r) => r.data);

export const listLessons = () => client.get("/lessons").then((r) => r.data);
export const createLesson = (payload) => client.post("/lessons", payload).then((r) => r.data);
export const createLessonComment = (lessonId, payload) =>
  client.post(`/lessons/${lessonId}/comments`, payload).then((r) => r.data);
export const adminLessons = (token) =>
  client.get("/admin/lessons", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const moderateLesson = (token, lessonId, action) =>
  client.post(`/admin/lessons/${lessonId}/moderate`, { action }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const moderateComment = (token, commentId, action) =>
  client.post(`/admin/comments/${commentId}/moderate`, { action }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminLogin = (email, password) =>
  client.post("/admin/login", { email, password }).then((r) => r.data);
export const adminStats = (token) =>
  client.get("/admin/stats", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminContributions = (token) =>
  client.get("/admin/contributions", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminExportUrl = () => `${API}/admin/export`;
export const adminContributionsExportUrl = () => `${API}/admin/contributions/export`;

export default client;
